import React, { useState } from 'react';
import { PageTitle } from '@/shared/ui/PageTitle/PageTitle';
import { Section } from '@/shared/ui/Section/Section';
import { Button } from '@/shared/ui/Button/Button';
import { Input } from '@/shared/ui/Input/Input';
import { Table } from '@/entities/Table';
import { useGetMaxBindingsQuery, useRegisterWebhookMutation, useSendTestMessageMutation } from '@/entities/Max';
import { useDispatch } from 'react-redux';
import { alertOpen } from '@/entities/Alert';
import { ColumnDef } from '@tanstack/react-table';
import styles from './MaxAdminPage.module.scss';

interface MaxBinding {
  id: number;
  phoneNumber: string;
  maxUserId: number;
  createdAt: string;
}

const MaxAdminPage = () => {
  const dispatch = useDispatch();
  const [testUserId, setTestUserId] = useState('');
  const [testText, setTestText] = useState('');
  const [page, setPage] = useState(1);

  const { data: bindingsData, isLoading } = useGetMaxBindingsQuery(page);
  const [registerWebhook] = useRegisterWebhookMutation();
  const [sendTest] = useSendTestMessageMutation();

  const handleRegister = async () => {
    try {
      await registerWebhook().unwrap();
      dispatch(
        alertOpen({
          content: { header: 'Успех', body: ['Вебхук успешно зарегистрирован'], footer: '' },
          isError: false,
        }),
      );
    } catch (e) {
      dispatch(
        alertOpen({
          content: { header: 'Ошибка', body: ['Ошибка при регистрации вебхука'], footer: '' },
          isError: true,
        }),
      );
    }
  };

  const handleSendTest = async () => {
    try {
      await sendTest({ max_user_id: Number(testUserId), text: testText }).unwrap();
      dispatch(
        alertOpen({
          content: { header: 'Успех', body: ['Тестовое сообщение отправлено'], footer: '' },
          isError: false,
        }),
      );
    } catch (e) {
      dispatch(
        alertOpen({
          content: { header: 'Ошибка', body: ['Ошибка при отправке тестового сообщения'], footer: '' },
          isError: true,
        }),
      );
    }
  };

  const columns: ColumnDef<MaxBinding>[] = [
    {
      accessorKey: 'id',
      header: 'ID',
    },
    {
      accessorKey: 'phoneNumber',
      header: 'Телефон',
    },
    {
      accessorKey: 'maxUserId',
      header: 'MAX User ID',
    },
    {
      accessorKey: 'createdAt',
      header: 'Дата привязки',
    },
  ];

  const data = bindingsData?.data || [];

  return (
    <div className={styles.container}>
      <PageTitle title="Управление MAX Messenger" />

      <Section title="Регистрация вебхука">
        <div className={styles.controlGroup}>
          <Button onClick={handleRegister}>Обновить вебхук</Button>
        </div>
      </Section>

      <Section title="Тестовое сообщение">
        <div className={styles.controlGroup}>
          <Input
            value={testUserId}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTestUserId(e.target.value)}
            placeholder="MAX User ID"
            error=""
          />
          <Input
            value={testText}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTestText(e.target.value)}
            placeholder="Текст сообщения"
            error=""
          />
          <Button onClick={handleSendTest}>Отправить</Button>
        </div>
      </Section>

      <Section title="Привязки пользователей">
        <div className={styles.tableWrapper}>
          {isLoading ? (
            <div>Загрузка...</div>
          ) : (
            <Table columns={columns} data={data} onSelect={() => {}} tableRef={{ current: {} }} />
          )}

          {bindingsData?.meta?.currentPage < (bindingsData?.meta?.lastPage || 1) && (
            <div className={styles.loadMoreWrapper}>
              <Button onClick={() => setPage((p) => p + 1)} disabled={isLoading} className={styles.loadMoreBtn}>
                {isLoading ? 'Загрузка...' : 'Показать ещё'}
              </Button>
            </div>
          )}
        </div>
      </Section>
    </div>
  );
};

export default MaxAdminPage;
